export const FORGE_REFRESH_RUN_STALE_AFTER_MS = 30 * 60 * 1000;

const TERMINAL_FORGE_REFRESH_RUN_POLL_ERROR_STATUSES = [401, 403, 404, 410];

export function refreshRunCreatedAtMs(createdAtUtc?: string | null): number {
  const createdAtMs = Date.parse(createdAtUtc ?? '');
  return Number.isFinite(createdAtMs) ? createdAtMs : Date.now();
}

export function isForgeRefreshRunFresh(createdAtMs: number, nowMs = Date.now()): boolean {
  return nowMs - createdAtMs < FORGE_REFRESH_RUN_STALE_AFTER_MS;
}

export function isForgeRefreshRunTimedOut(createdAtMs: number, nowMs = Date.now()): boolean {
  return !isForgeRefreshRunFresh(createdAtMs, nowMs);
}

export function isTerminalForgeRefreshRunPollError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const status = (error as Error & { status?: unknown }).status;
  return (
    typeof status === 'number' && TERMINAL_FORGE_REFRESH_RUN_POLL_ERROR_STATUSES.includes(status)
  );
}
